export const getBackendApiUrl = () => {
  const defaultPort = process.env.REACT_APP_API_PORT;
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;

   if (hostname === "localhost" || 'admin.data-craft.net') {
    return process.env.REACT_APP_API_BASE_URL;
  }

  return `${protocol}//${hostname}:${defaultPort}`;
};
